<template>
    <div>

        <vue-headful title="Incident Import :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/incidents`">
                        <i class="fa fa-list"></i> Incidents
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    Import
                </li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <div class="row form-group">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">File</label>
                    <div class="col-sm-8">

                        <b-form-file v-model="file" class="mt-3" plain />
                        <span v-if="errors.file" class="text-danger">
                            <span v-for="error in errors.file">{{ error }}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-success" @click="importFile" :disabled="saving">
                    Import File
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: false,
                saving: false,
                file: null,
                errors: {},
            }
        },

        methods: {
            importFile() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Setup payload
                var payload = {

                };

                //Send it
                this.$http
                .postWithSingleFile('incident/import', payload, this.file)
                .then(response => {
                    this.$toastr.success('Incidents Imported');

                    //Return to main list?
                    //this.$router.push('/incidents');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },
    }
</script>
